import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import { PeriodEndReportFundOverviewDatapoints } from 'further-types/lp/period-end-report';
import theme from '../Pdf/components/theme';
import PeriodEndReportPage from './components/pdf/PeriodEndReportPage';
import PeriodEndReportDatapointsTable from './components/pdf/PeriodEndReportDatapointsTable';
import SectionTitle from './components/pdf/SectionTitle';
import { PeriodEndReportSectionPageProps } from './types';

const styles = StyleSheet.create({
  sectionTitle: {
    paddingBottom: theme.spacing(theme.spacingSizes.md),
  },
});

type Props = PeriodEndReportSectionPageProps & {
  datapoints: PeriodEndReportFundOverviewDatapoints;
};

const FundOverview: FC<Props> = ({ datapoints, sectionNumber, ...rest }) => {
  return (
    <PeriodEndReportPage {...rest} header={`0${sectionNumber} – Fund overview`}>
      <SectionTitle
        sectionNumber={sectionNumber}
        title="Fund overview"
        style={styles.sectionTitle}
      />
      <PeriodEndReportDatapointsTable datapoints={datapoints} />
    </PeriodEndReportPage>
  );
};

export default FundOverview;
